export default __webpack_public_path__ + "static/media/picpay.7b11a520.png";